import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.333 1.332a2 2 0 0 1 1.997 1.883l.003.117a2 2 0 0 1 2 2 4 4 0 0 1-3.85 3.997l-.15.003H8.666l.1.003a1.33 1.33 0 0 1 1.23 1.226l.004.104v2.667a1.334 1.334 0 0 1-1.233 1.33l-.1.003H7.333a1.334 1.334 0 0 1-1.33-1.233l-.003-.1v-2.667a1.333 1.333 0 0 1 1.233-1.33l.1-.003v-.667a.667.667 0 0 1 .589-.662L8 8h3.333A2.667 2.667 0 0 0 14 5.332a.666.666 0 0 0-.589-.662l-.078-.005-.003.118a2 2 0 0 1-1.88 1.879l-.117.003H4.667A2 2 0 0 1 2.67 4.783l-.003-.118V3.332a2 2 0 0 1 1.882-1.997l.117-.003z"
    }, null, -1)
  ])))
}
export default { render: render }